import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  AppBar,
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
  alpha,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import { useColorMode } from "../../../contexts/ColorModeContext";
import { useControladoriaHeaderActions } from "./ControladoriaPageActionsContext";
import { getNavItemByPath } from "./navConfig";

const ControladoriaMuiHeader = ({ onMenuClick }) => {
  const { mode } = useColorMode();
  const { pathname } = useLocation();
  const currentNav = useMemo(() => getNavItemByPath(pathname), [pathname]);
  const { onRefresh, onFilter, refreshing } = useControladoriaHeaderActions();

  const pageTitle = currentNav?.label || "Controladoria";
  const pageSubtitle = currentNav
    ? "Rotina ativa no módulo de Controladoria"
    : "Selecione uma rotina no menu";

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={(theme) => ({
        width: "100%",
        bgcolor:
          mode === "dark"
            ? alpha(theme.palette.background.paper, 0.94)
            : alpha("#FFFFFF", 0.92),
        color: "text.primary",
        borderBottom: `1px solid ${theme.palette.divider}`,
      })}
    >
      <Toolbar sx={{ gap: 1, minHeight: 58, px: { xs: 1.5, md: 2.5 } }}>
        {onMenuClick && (
          <IconButton
            color="primary"
            edge="start"
            aria-label="Abrir menu"
            onClick={onMenuClick}
            sx={{ display: { md: "none" }, mr: 0.25 }}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" fontWeight={700} noWrap>
            {pageTitle}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            {pageSubtitle}
          </Typography>
        </Box>

        <Stack direction="row" spacing={0.5} alignItems="center">
          <Tooltip title={onRefresh ? "Atualizar" : "Atualizar indisponível nesta tela"}>
            <span>
              <IconButton
                color="primary"
                size="small"
                aria-label="Atualizar"
                disabled={!onRefresh || refreshing}
                onClick={() => onRefresh?.()}
              >
                {refreshing ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  <RefreshIcon fontSize="small" />
                )}
              </IconButton>
            </span>
          </Tooltip>

          <Tooltip
            title={
              onFilter ? "Gerenciar filtros" : "Filtros indisponíveis nesta tela"
            }
          >
            <span>
              <IconButton
                color="primary"
                size="small"
                aria-label="Filtros"
                disabled={!onFilter}
                onClick={() => onFilter?.()}
              >
                <FilterAltOutlinedIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default ControladoriaMuiHeader;
